//@flow

import React, {useState, useEffect} from 'react';
import {colors} from '../../../../assets/styles/colors';
import {makeStyles, Hidden} from '@material-ui/core';
import useStorePoliciesAndPrivacy from '../utils/useStorePoliciesAndPrivacy';
import LoadingSpinner from '../../../../elements/LoadingSpinner/LoadingSpinner';
import HeaderTitle from '../components/HeaderTitle/HeaderTitle';
import {useIsFeatureInTier} from '../../../../utils/component';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CustomEditor from '../components/CustomEditor/CustomEditor';
import {useTypedSelector} from '../../../../store';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#FFFFFF',
    '& .w-md-editor-toolbar': {
      left: '0!important',
    },
    padding: theme.spacing(2, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  containerEditor: {
    position: 'relative',
    borderRadius: 8,
    border: '1px solid #E8E8ED',
    padding: theme.spacing(1.5),
    backgroundColor: colors.grey200,
    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
  hiddenBlock: {
    borderRadius: '8px 8px 0 0',
    backgroundColor: colors.grey200,
    height: theme.spacing(6),
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      height: 0,
    },
  },
  buttonSave: {
    marginRight: theme.spacing(2),
    color: colors.grey900,
    height: 24,
    fontSize: 14,
    fontWeight: 600,
    border: '1px solid #D4D4DD',
    padding: theme.spacing(1, 3),
    backgroundColor: '#FFFFFF',
  },
}));

export default function PoliciesAndPrivacy() {
  const {
    isLoading,
    policiesAndPrivacy,
    savePolicyAndPrivacy,
  } = useStorePoliciesAndPrivacy();

  const classes = useStyles();

  const [description, setDescription] = useState('');

  const legalSetting = useTypedSelector(
    state => state.legalConfig.legalSetting
  );

  const hasTermsNConditionsInformationFeature = useIsFeatureInTier(
    'STORE_POLICIES'
  );

  useEffect(() => {
    if (policiesAndPrivacy) {
      setDescription(policiesAndPrivacy.description);
    }
  }, [policiesAndPrivacy]);

  const handleSavePolicyAndPrivacy = () => {
    savePolicyAndPrivacy(legalSetting?.policiesAndPrivacyEnabled, description);
  };

  return (
    <div className={classes.root} data-color-mode="light">
      {isLoading && <LoadingSpinner />}

      <HeaderTitle
        title="Políticas y privacidad"
        description="Describe cómo recopila, utiliza y protege la información de sus clientes."
        enabledKeyName="policiesAndPrivacyEnabled"
        enabled={legalSetting?.policiesAndPrivacyEnabled}
      />
      <div className={classes.containerEditor}>
        <div className={classes.hiddenBlock}>
          <Hidden smDown>
            <CustomButton
              disabled={!hasTermsNConditionsInformationFeature}
              className={classes.buttonSave}
              onClick={handleSavePolicyAndPrivacy}
            >
              Guardar
            </CustomButton>
          </Hidden>
        </div>
        <CustomEditor
          selected
          noBorder
          height={252}
          idx={0}
          text={description}
          onChange={text => setDescription(text)}
          disabled={!hasTermsNConditionsInformationFeature}
        />
        {hasTermsNConditionsInformationFeature && (
          <Hidden mdUp>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                margin: '1rem 0 0 0',
              }}
            >
              <CustomButton
                disabled={!hasTermsNConditionsInformationFeature}
                className={classes.buttonSave}
                onClick={handleSavePolicyAndPrivacy}
              >
                Guardar
              </CustomButton>
            </div>
          </Hidden>
        )}
      </div>
    </div>
  );
}
